import styled from 'styled-components';
import { PageHeader } from 'antd';

import colors from 'theme/colors';

export const PricingLayoutPageHeaderStyled = styled(PageHeader)`
  padding-top: 0;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-bottom: 1px solid ${colors.background};
`;
